import React, { useEffect } from 'react';
import { Card, Typography, Result, Button, Space } from 'antd';
import { GlobalOutlined, LoadingOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export const WebsiteRedirect = ({ setLoading, showMessage, supportLinks }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            window.open(supportLinks.website, '_blank');
        }, 3000);
        
        return () => clearTimeout(timer);
    }, [supportLinks.website]);

    return (
        <div style={{ padding: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <Card style={{ maxWidth: 600 }}>
                <Result
                    icon={<GlobalOutlined style={{ color: '#1890ff', fontSize: 72 }} />}
                    title="در حال انتقال به وب‌سایت"
                    subTitle="لطفاً منتظر بمانید..."
                    extra={[
                        <Button 
                            type="primary" 
                            key="open"
                            onClick={() => window.open(supportLinks.website, '_blank')}
                            size="large"
                        >
                            باز کردن وب‌سایت
                        </Button>,
                        <Button 
                            key="copy"
                            onClick={() => {
                                navigator.clipboard.writeText(supportLinks.website);
                                showMessage('success', 'لینک کپی شد');
                            }}
                        >
                            کپی لینک
                        </Button>
                    ]}
                />
                <Space direction="vertical" style={{ width: '100%', textAlign: 'center', marginTop: 24 }}>
                    <LoadingOutlined style={{ fontSize: 24 }} />
                    <Paragraph type="secondary">
                        در صورت عدم انتقال خودکار، روی دکمه "باز کردن وب‌سایت" کلیک کنید.
                    </Paragraph>
                    <Paragraph>
                        <a href={supportLinks.website} target="_blank" rel="noopener noreferrer">
                            {supportLinks.website}
                        </a>
                    </Paragraph>
                </Space>
            </Card>
        </div>
    );
};